import { Injectable, NgZone, OnDestroy } from '@angular/core'
import { AuthService } from '@services/auth.service'
import { RealtimeHealthService } from '@services/realtime/realtime-health.service'
import { ElectronicProcessPaginationRun } from '@models/planning/electronic-process-pagination.model'
import { ProcessTopicSocket } from '@services/socket/process-topic-socket'
import { StompConnectionService } from '@services/socket/stomp-connection.service'

/**
 * Paginação do processo eletrônico em tempo real (spec 002): cada mudança de uma execução (publicação, inclusão,
 * simulação, aplicação, alteração que desatualiza) chega em `/topic/tenant.{tenantId}.electronic-process-pagination.process.{processId}`,
 * com o mesmo corpo do `GET electronic-processes/{id}/pagination-runs/{runId}`.
 */
@Injectable({ providedIn: 'root' })
export class ElectronicProcessPaginationSocketService extends ProcessTopicSocket<ElectronicProcessPaginationRun> implements OnDestroy {
	protected readonly channel = 'pagination'
	protected readonly topic = 'electronic-process-pagination'

	constructor(health: RealtimeHealthService, authService: AuthService, stomp: StompConnectionService, zone: NgZone) {
		super(health, authService, stomp, zone)
	}

	protected parse(body: unknown): ElectronicProcessPaginationRun {
		return new ElectronicProcessPaginationRun(body as Partial<ElectronicProcessPaginationRun>)
	}

	ngOnDestroy(): void {
		void this.disconnect()
	}
}
